<template>
    <div class="relative">
		<div class="fixed white" style="width: 100%;" id="tool-bar">
			<v-row style="width: 100%" align="center" justify="start" class="ma-0">
				<v-col cols="auto">
					<slot name="breadcrumbs" :item="true"></slot>
				</v-col>
                <v-spacer/>
                <v-col cols="auto">
                    <v-btn  
                        :to="{
                            name: 'materials-journals',
                            params: {
                                id: this.$route.query.invoiceId ? this.$route.query.invoiceId : null
                            }
                        }"
                        color="grey white--text"
                    >
                        <v-icon small class="me-1"> mdi-arrow-left-circle </v-icon>
                        {{ $t('buttons.back') }}
                    </v-btn>
                </v-col>
                <v-col cols="auto" v-if="$route.query.id">
                    <!-- export -->
                    <v-menu offset-y>
                        <template v-slot:activator="{ on }">
                            <v-btn dark color="printingColor" class="px-2" v-on="on">
                                <span class="d-flex align-center">
                                    <v-icon color="white">mdi-export-variant</v-icon>
                                    <span style="font-size: 14px">
                                        {{$t('MaterialStatmentPage.export')}}
                                    </span>
                                </span>
                            </v-btn>
                        </template>

                        <bee-list>
                            <!-- pdf -->
                            <bee-list-item
                                context="statement"
                                :item="exportItems[0]"
                                dense
                                @click="exportAs('pdf')"
                            ></bee-list-item>
                            
                            <!-- excel -->
                            <bee-list-item
                                context="statement"
                                :item="exportItems[1]"
                                dense
                                @click="exportAs('excel')"
                            ></bee-list-item>
                        </bee-list>
                    </v-menu>
                </v-col>
			</v-row>
			<v-layout wrap class="d-flex flex-row my-border rounded-lg mx-3 mb-3 align-center">
                <v-col cols="auto" lg="2" class="d-flex flex-column px-1">
                    <v-autocomplete 
                        v-model="warehouseId"
                        :items="(userTypePermission === userType.warehouseKeeper && multipleWarehouses) ? warehousesForKeeper : warehouses"
                        :item-text="(userTypePermission === userType.warehouseKeeper && multipleWarehouses) ? 'warehouse_name' : 'name'"
                        :item-value="(userTypePermission === userType.warehouseKeeper && multipleWarehouses) ? 'warehouse_id' : 'id'"
                        dense
                        outlined
                        :label="$t('inputs.warehouse')"
                        hide-details
                        @change="materials_id=[]"
                    />
                </v-col>
				<v-col cols="auto" lg="3" class="d-flex flex-column px-1">
                    <bee-material-autocomplete 
                        :label="$t('MaterialStatmentPage.material-name-or-num')" 
                        context="statement"
                        color="primary" 
                        v-model="materials_id" 
                        :items="materials.filter(c => c.warehouse_id === warehouseId)" 
                        :clearable="true"
                        :hide-details="true"
                        :action_name="actions.GET"
                        :loading="materialsLoading"
                        ref="BeeAutocomplete"
                        item-text="name"
                        item-value="id"
                        @keydown-enter-prevent="search()"
                        :with-balance="true"
                        :item-color="item => item.type === type.main ? 'orangeLighten5' : null"
                        :multiple="true"
                    ></bee-material-autocomplete>
                </v-col>
                <!-- start date -->
                <v-col sm="auto" lg="auto" cols="12" class="d-flex flex-column px-1">
                    <bee-date-picker
                        context="statement"
                        :label="$t('MaterialStatmentPage.from-date')"
                        v-model="from_date"
                        :action-name="actions.GET"
                        :hide-details="true"
                        :disabled="false"
                        @keydown-enter-prevent="search()"
                    ></bee-date-picker>
                </v-col>
                <!-- end date -->
                <v-col sm="auto" lg="auto" cols="12" class="d-flex flex-column px-1">
                    <bee-date-picker
                        v-model="to_date"
                        :label="$t('MaterialStatmentPage.to-date')"
                        context="statement"
                        :action-name="actions.GET"
                        :hide-details="true"
                        :disabled="false"
                        @keydown-enter-prevent="search()"
                    ></bee-date-picker>
                </v-col>

                <!-- materials -->
                <!-- <v-col cols="12" md="2" v-if="useMaterialStatusDeliver"> -->
                <v-col v-if="useMaterialStatusDeliver">
                    <v-autocomplete
                        v-model="deliveryStatusIds"
                        :items="deliveryStatus"
                        item-text="name"
                        item-value="id"
                        :label="$t('MaterialStatmentPage.delivery-statuses')"
                        dense
                        outlined
                        hide-details
                        multiple
                    >
                        <template v-slot:prepend-item>
                            <v-list-item
                                ripple
                                @mousedown.prevent
                                @click="toggle"
                            >
                                <v-list-item-action>
                                    <v-icon :color="deliveryStatusIds.length > 0 ? 'indigo darken-4' : ''">
                                        {{ checkIcon }}
                                    </v-icon>
                                </v-list-item-action>
                                <v-list-item-content>
                                    <v-list-item-title>
                                        {{ $t('select-all') }}
                                    </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <v-divider class="mt-2"></v-divider>
                        </template>

                        <template v-slot:selection="{ item, index }">
                            <div v-if="index === 0">
                                <span>{{ item.name }}</span>
                            </div>
                            <span
                                v-if="index === 1"
                                class="grey--text text--darken-2 text-caption ms-2"
                                >
                                (+{{ deliveryStatusIds.length - 1 }})
                            </span>
                        </template>
                    </v-autocomplete>
                </v-col>
                <v-spacer></v-spacer>
                <!-- update table -->
                <v-col lg="auto" sm='auto' cols="12" class="d-flex justify-end align-center px-1">
                    <bee-btn
                        context="statement"
                        :action-name="actions.EDIT"
                        :content="$t('MaterialStatmentPage.refresh')"
                        :disabled="materialsLoading || searchLoading"
                        outer-class="mt-0 me-3"
                        color="blueGray"
                        @click="search()"
                    ></bee-btn>
                    <v-icon small color="grey" @click="cancel()" :searchLoading="loading">fa-times-circle</v-icon>
                </v-col>
            </v-layout>
        </div>
        <!-- table -->
        <div class="ma-auto absolute pb-2" id="main" style="width: 100%; height: auto">
        <v-card flat>
            <v-card-text class="pt-0 px-3">
                <bee-handy-table
                    :headers="headers"
                    :items="items || []"
                    :fixed-header="true"
                    :height="$vuetify.breakpoint.height - (!$route.query.id ? 305 : 315)"
                    ref="table"
                    :zebra="true"
                    :divider="true"
                    :loading="searchLoading"
                    pagination-on-scroll
                    shown-rows-text=""
                    :context-menu-items="contextMenuItems"
                    @contextmenu:row="(e, data) => {contextMenuItem = data.item; entryHasInvoice = Boolean(data.item.invoice_id)}"
                    @context-menu-redirect="redirectToJournal($event.item); contextMenuItem"
                    @context-menu-invoiceRedirect="redirectToInvoice($event.item); contextMenuItem"
                    @dblclick:row="(e, { item }) => {
                        entryHasInvoice = Boolean(item.invoice_id)
                        entryHasInvoice ? redirectToInvoice(item) : redirectToJournal(item)
                    }"
                >
                    <template v-slot:item.options="{ item }">
						<div class="text-center">
							<v-menu offset-y>
								<template v-slot:activator="{ on, attr }">
									<v-btn
										small
										icon
										v-bind="attr"
										v-on="on"
										width="32"
                                        @click="entryHasInvoice = Boolean(item.invoice_id)"
									>
										<v-icon>
											mdi-dots-vertical
										</v-icon>
									</v-btn>
								</template>
								<v-list dense>
									<v-list-item @click="redirectToJournal(item)">
										<v-list-item-content class="pa-0">
											{{ $t('MaterialStatmentPage.go-to-the-journal-entry') }}
										</v-list-item-content>
									</v-list-item>
									<v-list-item v-if="entryHasInvoice" @click="redirectToInvoice(item)">
										<v-list-item-content class="pa-0">
											{{ $t('context-menu.go-to-invoice'),}}
										</v-list-item-content>
									</v-list-item>
								</v-list>
							</v-menu>
						</div>
					</template>
                </bee-handy-table>
            </v-card-text>
        </v-card>
        </div>
        <!-- fixed footer -->
        <v-bottom-navigation id="footer" app class="px-3" horizontal background-color="#E1E2E4">
            <v-row align="center" justify="center" justify-lg="start">
                <v-col cols="auto" lg="auto" v-if="useMaterialStatusDeliver">
                    <div v-if="deliveryStatusMenu === true && deliveryStatusIds.length > 0">
                        <v-menu
                            v-model="showDeliveryStatus"
                            top
                            offset-y
                            right
                            transition="slide-y-transition"
                            max-width="400"
                            :close-on-click="false"
                            :close-on-content-click="false"
                        >
                            <template v-slot:activator="{ on }">
                                <v-btn
                                    class="pe-0"
                                    depressed
                                    color="transparent"
                                    v-on="on"
                                    @click="showDeliveryStatus = !showDeliveryStatus"
                                >
                                    <v-icon class="mx-1">{{ showDeliveryStatus ? 'mdi-chevron-down' : 'mdi-chevron-up'  }}</v-icon>
                                        {{ $t('MaterialStatmentPage.show-material-status-footer') }}
                                </v-btn>
                            </template>
                            <v-card
                                :width="200"

                            >
                                <v-card-text>
                                    <div class="d-flex">
                                        <div class="d-flex flex-column">
                                            <div
                                                v-for="status in summary.balance_statuses.filter(status =>
                                                    deliveryStatusIds.includes(String(status.delivery_status_id))
                                                )"
                                                :key="status.delivery_status_id"
                                                >
                                                    {{ getDeliveryStatusById(status.delivery_status_id).name }}
                                            </div>
                                        </div>

                                        <v-spacer></v-spacer>

                                        <div class="d-flex flex-column">
                                            <div v-for="status in summary.balance_statuses.filter(status =>
                                                    deliveryStatusIds.includes(String(status.delivery_status_id))
                                                )"
                                                :key="status.delivery_status_id" 
                                                class="d-flex flex-column"
                                                :class="
                                                    status.balance.quantity >= 0 
                                                        ? (
                                                            status.balance.quantity > 0 
                                                                ? 'green--text' 
                                                                : ''
                                                        ) 
                                                        : 'red--text'
                                                    "
                                            >
                                                {{ status.balance.quantity.toLocaleString('en') }}
                                            </div>
                                        </div>
                                    </div>
                                </v-card-text>
            
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn @click="showDeliveryStatus = false" x-small depressed color="grey--text">
                                        <v-icon>mdi-close</v-icon>
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-menu>
                    </div>
                </v-col>
                <v-spacer></v-spacer>
                <!-- balance -->
                <v-col cols="auto" lg="auto" class="ma-0 pa-0 d-flex">
                    <bee-outlined-header-info
                        border-color="transparent"
                        :head="$t('MaterialStatmentPage.final-balance')"
                        :column="false"
                    >
                        <template  v-slot:content="{}">
                            <bee-material-amount-label
                                empty-state="_"
                                :value="summary.balance"
                            ></bee-material-amount-label>
                        </template>
                    </bee-outlined-header-info>
                </v-col>
                <!-- sum_input_quantity -->
                <v-col cols="auto" lg="auto" class="ma-0 pa-0 d-flex">
                    <bee-outlined-header-info
                        border-color="transparent"
                        :head="$t('MaterialStatmentPage.total-incoming-quantity')"
                        :column="false"
                    >
                        <template  v-slot:content="{}">
                            <bee-quantity-label
                                color="green"
                                empty-state="_"
                                :value="summary.sum_input_quantity"
                            ></bee-quantity-label>
                        </template>
                    </bee-outlined-header-info>
                </v-col>
                <!-- sum_output_quantity -->
                <v-col cols="auto" lg="auto" class="ma-0 pa-0 d-flex">
                    <bee-outlined-header-info
                        border-color="transparent"
                        :head="$t('MaterialStatmentPage.total-outcoming-quantity')"
                        :column="false"
                    >
                        <template  v-slot:content="{}">
                            <bee-quantity-label
                                color="red"
                                empty-state="_"
                                :value="summary.sum_output_quantity"
                            ></bee-quantity-label>
                        </template>
                    </bee-outlined-header-info>
                </v-col>
            </v-row>
        </v-bottom-navigation>
    </div>
</template>

<script>
import actions from "../../../permissions/actions-names.js"
import store from "../../../store/index"
import { mapState, mapGetters } from 'vuex';
import ls from '../../../settings/localStorageExtension';
import { invoiceType, userType, type } from '@/helpers/enums';
import { multipleWarehouses, separationOfInvoices, useMaterialStatusDeliver } from '@/configs/global'
export default {
    data: () => ({
        materials_id: [],
        from_date: null,
        to_date: null,
        searchLoading:false,
        actions,
        default_summary:{
            balance: { quantity: null, unit_size_id: null },
            sum_input_quantity: { quantity: null, unit_size_id: null },
            sum_output_quantity: { quantity: null, unit_size_id: null },
        },
        warehouseId: null,
        invoiceType,
        userType,
        type,
        multipleWarehouses,
        loading: false,
        with_children_material: false,
        showDeliveryStatus: false,

        deliveryStatusMenu: false,
        useMaterialStatusDeliver,
        showMaterialName: true,
        deliveryStatusIds: [],
        entryHasInvoice: false,
        materialsLoading : false
    }),
    watch: {
        '$route.query.id' (newVal, oldVal) {
            if(!newVal && oldVal ) {
                this.$router.push({name: 'material-statment', query: {id: oldVal}});
            }
        }
    },
    computed:{
        ...mapState("statements", ["material_statement"]),
        ...mapState("configs", ["configs"]),
        ...mapState("invoices", ["simplified_buy_invoices"]),
        ...mapState("invoices", ["simplified_sale_invoices"]),
        ...mapState("materials", ["materials"]),
        ...mapState("materialsJournals", ["materials_journals"]),
        ...mapState({
            warehouses: state => state.warehouses.warehouses,
            userTypePermission: state => state.permissions.user_type,
            // warehousesForWarehousekeepr: state => state.configs.configs.warehouse,
            warehousesForKeeper: state => state.permissions.warehousesForKeeper,
            deliveryStatus: state => state.deliveryStatus.deliveryStatus
        }),

        ...mapGetters({
            getAccountById: 'configs/getAccountById',
            getMaterialById: 'materials/getMaterialById',
            getDeliveryStatusById: 'deliveryStatus/getDeliveryStatusById'
        }),

        exportItems() {
            return [
                {
                    text: this.$t('MaterialStatmentPage.print-material-statement'),
                    icon: 'mdi-printer',
                    context: 'statement',
                    action_name: actions.EXPORT_AS_PDF
                },
                {
                    text: this.$t('MaterialStatmentPage.export-as-excel'),
                    icon: 'mdi-microsoft-excel',
                    context: 'statement',
                    action_name: actions.EXPORT_AS_PDF
                },
            ]
        },
        summary(){
            return this.material_statement?.material_report_summary ? this.material_statement?.material_report_summary : this.default_summary
        },
        invoices(){
            return [{ id: null, no: null}].concat(this.simplified_sale_invoices, this.simplified_buy_invoices)
        },
        journals(){
            return [{ id: null, no: null }].concat(this.materials_journals)
        },

        // headers0(){
        //     return [
        //     { 
        //         text: this.$t('MaterialStatmentPage.headers.balance'),
        //         value: 'balance',
        //         type: 'numeric',
        //         width: "10%" 
        //     },
        //     { 
        //         text: this.$t('MaterialStatmentPage.headers.income-quantity'),
        //         value: 'in_quantity',
        //         type: 'numeric',
        //         width: "10%" 
        //     },
        //     { 
        //         text: this.$t('MaterialStatmentPage.headers.outcome-quantity'),
        //         value: 'out_quantity',
        //         type: 'numeric',
        //         width: "10%" 
        //     },
        //     { 
        //         text: this.$t('MaterialStatmentPage.headers.count'),
        //         value: 'count',
        //         type: 'numeric',
        //         width: "5%" 
        //     },
        //     { 
        //         text: this.$t('MaterialStatmentPage.headers.note'),
        //         value: 'notes',
        //         type: 'string',
        //         width: "15%" 
        //     },
        //     { 
        //         text: this.$t('MaterialStatmentPage.headers.date'),
        //         value: 'date',
        //         type: 'date',
        //         width: "8%" 
        //     },
        //     { 
        //         text: this.$t('MaterialStatmentPage.headers.price'),
        //         value: 'price',
        //         type: 'money',
        //         width: "10%" 
        //     },
        //     { 
        //         text: this.$t('MaterialStatmentPage.headers.document-no'),
        //         value: 'doc_no',
        //         type: 'string',
        //         width: "5%" 
        //     },
        //     { 
        //         text: this.$t('MaterialStatmentPage.headers.materials-journal-balance'),
        //         value: ' materials_journal_id',
        //         type: 'autocomplete', 
        //         width: this.$emerald.ifLang('es', '15%','7%'),
        //         settings: { itemText: 'no', itemValue: 'id', items: this.journals }
        //     },
        //     { 
        //         text: this.$t('MaterialStatmentPage.headers.invoice-balance'),
        //         value: ' invoice_id',
        //         type: 'autocomplete',
        //         width: this.$emerald.ifLang('es', '15%','5%'),
        //         settings: { itemText: 'no', itemValue: 'id', items: this.invoices }
        //     },
        //     { 
        //         text: this.$t('MaterialStatmentPage.headers.sequence'),
        //         value: 'material_entry_no',
        //         type: 'string',
        //         width: "5%"
        //     },
        //     { 
        //         text: this.$t('MaterialStatmentPage.headers.account'),
        //         value: 'account_id',
        //         type: 'accounts-autocomplete',
        //         width: "10%",
        //         settings: { itemValue: 'id', items: this.configs.accounts }
        //     },
        // ]},

        headers(){
            const headers = [
            { 
                text: this.$t('MaterialStatmentPage.headers.balance'),
                value: 'balance',
                type: 'number-format',
                width: '5%',
                sortable: false
            },
            {
                text: this.$t('inputs.warehouse'),
                name: 'warehouse',
                value: 'material_id',
                setValueExpr: value => this.warehouses.find(c => c.id === this.materials.find(e => e.id === value).warehouse_id).name,
                sortable: false

            },
            { 
                text: this.$t('MaterialStatmentPage.headers.income-quantity'),
                value: 'in_quantity',
                type: 'number-format',
                width: '7%',
                sortable: false,
                columnClass: 'px-1'
            },
            { 
                text: this.$t('MaterialStatmentPage.headers.outcome-quantity'),
                value: 'out_quantity',
                type: 'number-format',
                width: '7%' ,
                sortable: false,
                columnClass: 'px-1'
            },
            { 
                text: this.$t('MaterialStatmentPage.headers.count'),
                value: 'count',
                type: 'number-format',
                width: '5%' ,
                sortable: false
            },
            { 
                text: this.$t('MaterialStatmentPage.headers.note'),
                value: 'notes',
                type: 'string',
                width: '10%' ,
                sortable: false
            },
            { 
                text: this.$t('MaterialStatmentPage.headers.date'),
                value: 'date',
                type: 'date',
                width: '7%' ,
                columnClass: 'px-1',
                sortable: false
            },
            { 
                text: this.$t('MaterialStatmentPage.headers.document-no'),
                value: 'doc_no',
                type: 'string',
                width: '5%' ,
                sortable: false
            },
            { 
                text: this.$t('MaterialStatmentPage.headers.materials-journal-balance'),
                value: 'materials_journal_id',
                setValueExpr: value => this.journals.find(c => c.id === value)?.no ?? '-',
                width: this.$emerald.ifLang('es', '15%','7%'),
                sortable: false,
                columnClass: 'px-0'
            },
            { 
                text: this.$t('MaterialStatmentPage.headers.invoice-balance'),
                value: 'invoice_no',
                width: this.$emerald.ifLang('es', '15%','5%'),
                sortable: false
            },
            { 
                text: this.$t('MaterialStatmentPage.headers.sequence'),
                value: 'material_entry_no',
                type: 'string',
                width: '3%',
                columnClass: 'px-1',
                sortable: false
            },
            { 
                text: this.$t('MaterialStatmentPage.headers.account'),
                value: 'account_id',
                setValueExpr: value => this.getAccountById(value)?.name,
                width: '18%',
                sortable: false
            },
            {
                text: '',
                name: 'options',
                value: 'options',
                width: 34,
                class: 'px-0',
                cellClass: 'px-0',
                sortable: false
            }
        ];
            if (this.showMaterialName) {
            headers.splice(1, 0,
                { 
                    text: this.$t('MaterialStatmentPage.headers.child-material'),
                    value: 'material_id',
                    setValueExpr: value => this.getMaterialById(value).name,
                    width: '18%',
                    sortable: false 
                }
            );
        }

            if (!this.isWarehousePermission) {
                headers.splice(6, 0,{ 
                    text: this.$t('MaterialStatmentPage.headers.price'),
                    value: 'price.amount',
                    type: 'number-format',
                    width: '6%' ,
                    sortable: false
                });
            }

            if(useMaterialStatusDeliver) {
                headers.splice(6, 0, 
                    {
                        text: this.$t('MaterialStatmentPage.headers.delivery-status'),
                        value: 'delivery_status_id',
                        name: 'deliveryStatusId',
                        setValueExpr: value => this.getDeliveryStatusById(value)?.name?? '-',
                        sortable: false,
                        width: '8%',
                        columnClass: 'px-1'
                    }
                );
            }

        return headers;
        },
        
        isWarehousePermission() {
            return (this.userTypePermission === userType.warehouseKeeper && separationOfInvoices) || (this.userTypePermission === userType.warehouseManger && separationOfInvoices)
        },

        items(){
		return this.material_statement?.material_report_rows?.map(obj=> ({
                    ...obj, 
                    in_quantity: obj.type == 1 ? obj.quantity?.quantity : null,
                    out_quantity: obj.type == 2 ? obj.quantity?.quantity : null
                })) 
        },

        contextMenuItems() {

            const contextMenuItems  = [
                {
                    title: this.$t('MaterialStatmentPage.go-to-the-journal-entry'),
                    event: 'redirect'
                },
            ];
            if(this.entryHasInvoice === true){
                contextMenuItems.push({
                    title: this.$t('context-menu.go-to-invoice'),
                    event: 'invoiceRedirect'
                })
            }
            return contextMenuItems
        },

        selectedAllDeliveryStatuses () {
            return this.deliveryStatusIds.length === this.deliveryStatus.length
        },

        selectedPartDeliveryStatuses () {
            return this.deliveryStatusIds.length > 0 && !this.selectedAllDeliveryStatuses
        },

        checkIcon () {
            if (this.selectedAllDeliveryStatuses) return 'mdi-close-box'
            if (this.selectedPartDeliveryStatuses) return 'mdi-minus-box'
            return 'mdi-checkbox-blank-outline'
        },
        materialsRequest() {
            return this.materials_id?.map(t => {
                const material = this.getMaterialById(t);
                return {
                    material_id: t,
                    is_parent: material?.type === type.main,
                    warehouse_id: material?.warehouse_id
                }
            }
            )
        }
    },
    mounted(){
        window.observer.observe(document.querySelector("#tool-bar"))
        window.observer.observe(document.querySelector("#footer"))
        // if (this.materials.filter(c => this.materials_id?.includes(c.id) && c.type === type.main).length) {
        //     this.with_children_material = true
        //     this.search()
        // }
        let promises = []
        if(!store.state.materials.materials.length) { 
            this.materialsLoading = true
            promises.push(store.dispatch("materials/fetchAll").then(() => {
                this.materialsLoading = false;
                this.warehouseId = this.materials.find(v => v.id === Array.isArray(this.$route.query.id) ? this.$route.query.id[0] : this.$route.query.id)?.warehouse_id || this.configs.warehouse.id
            }))
        }
        let configs = JSON.parse(JSON.stringify(store.state.configs.configs))
        if(Object.keys(configs).length == 0)
            promises.push(store.dispatch("configs/fetchAll"))

        let buy_invoices = JSON.parse(JSON.stringify(store.state.invoices.simplified_buy_invoices))
        if(buy_invoices.length == 0)
            promises.push(store.dispatch("invoices/fetchAll", { invoiceType: invoiceType.buy }))

        let sale_invoices = JSON.parse(JSON.stringify(store.state.invoices.simplified_sale_invoices))
        if(sale_invoices.length == 0)
            promises.push(store.dispatch("invoices/fetchAll", { invoiceType: invoiceType.sale }))
        if(!this.warehouses.length) {
            promises.push(store.dispatch('warehouses/fetchAll'))
        }
            Promise.all(promises).then(()=>{
                let configs = JSON.parse(JSON.stringify(store.state.configs.configs))
                store.dispatch("materialsJournals/fetchAll", { fromDate: configs.financial_file.start_date, toDate: new Date().toISOString().substr(0, 10) })
                this.setFocus()
                this.reSetDates()
                if(useMaterialStatusDeliver) {
                    !(this.deliveryStatus.length > 0) ? this.$store.dispatch('deliveryStatus/fetchAll') : null
                }
                if (this.$route.query.id){
                    if (Array.isArray(this.$route.query.id)) {
                        this.materials_id = this.$route.query.id.map(c => +c);
                    } else {
                        this.materials_id.push(+this.$route.query.id);
                    }
                    this.search()
                } else {
                    this.warehouseId = this.warehouses.find(c => c.is_default === true)?.id
                }
            })

    },
    beforeDestroy(){
        store.dispatch("statements/clear")
    },
    methods:{
        search(){
        /*for replace later*/
		if(this.materials_id[0])
			{
                const materialsRequest = this.materialsRequest
                this.deliveryStatusMenu = true;
				this.searchLoading = true;
                this.showMaterialName = !(materialsRequest.length === 1 && materialsRequest[0].is_parent === false)
				store.dispatch("statements/fetchMaterialStatement", { 
					materialsRequest: materialsRequest, 
					from_date: this.from_date, 
					to_date: this.to_date,
                    deliveryStatusIds: this.deliveryStatusIds
				})
				.then(()=>{
                    this.$router.replace({ name: "material-statment", query: { id: this.materials_id }})
				}).finally(()=>{ 
					this.searchLoading = false
				})
			}
        },
        cancel() {
            this.reSet()
            this.$router.push({ name: "materials-statement" })
        },
        reSet(){
            this.reSetDates()
            this.materials_id = []
            this.searchLoading = false
            this.setFocus();
            store.dispatch("statements/clear")
        },
        reSetDates(){
            this.from_date = new Date().toISOString().substr(0, 10)
            this.to_date = new Date().toISOString().substr(0, 10)
            if(this.configs)
                this.from_date = this.configs.financial_file.start_date
        },
        setFocus(){
            this.$refs['BeeAutocomplete'].$refs.BeeMaterialAutocomplete.$refs.BeeAutocomplete.focus()
        },
        redirectToJournal(entry){
            let routeData = this.$router.resolve({ name: 'materials-journal', params: { id: entry.materials_journal_id }, query: { entryId: entry.id }});
            window.open(routeData.href, '_blank');
        },
       redirectToInvoice(entry) {
            let routeData
            routeData = this.$router.resolve({
                name: entry.invoice_type === this.invoiceType.buy ? 'invoices-buy' : entry.invoice_type === this.invoiceType.sale ? 'invoices-sale' : entry.invoice_type === this.invoiceType.buyRefund ? 'buy-invoice-refund' : entry.invoice_type === this.invoiceType.saleRefund ? 'sale-invoice-refund' : null,
                params:{id: entry.invoice_id},
                query: {withCategory: true}
            })
            window.open(routeData.href, '_blank')
        },
        exportAs(type){
            this.$store.dispatch('reports/MaterialStatementReport', {
                type,
                financialFileId: this.configs.financial_file.id,
                userId: ls.getLocalUser().id,
                materialRequests: JSON.stringify(this.materialsRequest),
                FromDate: this.from_date,
                ToDate: this.to_date,
                withDeliveryStatus: useMaterialStatusDeliver,
                deliveryStatusIds: this.deliveryStatusIds.length > 0 ? this.deliveryStatusIds : null,
            })
        },

        toggle () {
            this.$nextTick(() => {
                if (this.selectedAllDeliveryStatuses) {
                    this.deliveryStatusIds = []
                } else {
                    this.deliveryStatusIds = this.deliveryStatus.slice()
                    this.deliveryStatusIds = this.deliveryStatus.map(c => c.id)
                }
            })
        },
    },

    // async beforeRouteEnter(to, from, next) {

    //     next();
    // },
}
</script>

<style scoped>
.border {
    border: 1px solid #f1f1f1;
    border-radius: 8px;
}
.rounded-right{
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
}
.rounded-bottom{
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
}
</style>